import { uploadURL } from '@/lib/axios';
import { API_CTX } from '@/config';

const createFormData = (file: File, fieldName = 'file') => {
  const fd = new FormData();
  fd.append(fieldName, file, file.name);
  return fd;
};

/**
 * Upload `svg` file for item:
 * {url}/items/{item_id}/icons
 */
export const uploadItemIcon = async (
  svg: File,
  itemId: string,
  onSuccess?: () => void,
  onError?: (message: string) => void
) => {
  const url = `${API_CTX}/items/${itemId}/icons`;
  const file = createFormData(svg);
  try {
    await uploadURL().post(url, file);
    onSuccess && onSuccess();
  } catch (err: any) {
    console.error(`## got upload error: ${err.message}`);
    onError && onError(err.message);
    throw new Error(err.message);
  }
};
